import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from "@angular/router"
import get from 'lodash-es/get'
import sweetAlert from 'bmAlert'
import { NewKeywordPage } from "../pages/new-keyword.page"
import { EditKeywordPage } from "../pages/edit-keyword.page"
import { EditRequestPage } from "../pages/edit-request.page"
import { Injectable } from "@angular/core"

@Injectable()
export class CanDeactivateKeywordPage implements CanDeactivate<EditKeywordPage|NewKeywordPage|EditRequestPage> {
  canDeactivate(component: NewKeywordPage|EditKeywordPage, route: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState: RouterStateSnapshot): Promise<boolean>|boolean {
    if (this.updatingPayment(nextState)) return true

    if (component.contentTypeId !== 99) {
      return this.canDeactivateKeywordForm(<NewKeywordPage|EditKeywordPage>component)
    } else {
      return this.canDeactivateVideoForm(<NewKeywordPage|EditRequestPage>component)
    }
  }

  canDeactivateKeywordForm(component: NewKeywordPage|EditKeywordPage): Promise<boolean> | boolean {
    const keywordFormComponent = component?.keywordForm || component?.multipassKeywordForm
    const { keyword } = keywordFormComponent || {}
    const keywordState = keyword ? keywordFormComponent?.form?.value?.state : 'paused'
    const formDirty = get(keywordFormComponent, 'form.dirty', true)

    if (formDirty && !['fulfilled','deleted'].includes(keywordState)) {
      return new Promise<boolean>((resolve, reject) => {
        sweetAlert.saveKeyword(keywordState, true, {
          onAbandonChanges: () => resolve(true),
          onContinueEditing: () => resolve(false),
          onSaveAsDraft: () => {
            keywordFormComponent.onSaveDraft()
            resolve(true)
          },
          onSaveAsActive: () => {
            keywordFormComponent.onSubmit('active')
            resolve(true)
          }
        })
      })
    }
    return true
  }

  canDeactivateVideoForm(component: NewKeywordPage|EditRequestPage): Promise<boolean> | boolean {
    const videoFormComponent = component.videoForm
    const videoState = get(videoFormComponent, 'form.value.request.state', null)
    const videoTitle = get(videoFormComponent, 'form.value.request.videoTitle', '')
    const sourceContent = get(videoFormComponent, 'form.value.request.sourceContent.content', '')
    const formDirty = get(component, 'videoForm.form.dirty', true)
    if (formDirty) {
      return new Promise<boolean>((resolve, reject) => {
        sweetAlert.saveKeyword(videoState, (videoTitle !== '' && sourceContent !== ''), {
          onAbandonChanges: () => resolve(true),
          onContinueEditing: () => resolve(false),
          onSaveAsDraft: () => {
            videoFormComponent.onSave('draft')
            resolve(true)
          },
          onSaveAsActive: () => {
            videoFormComponent.onSave('active')
            resolve(false)
          },
        })
      })
    }
    return true
  }

  private updatingPayment(nextState: RouterStateSnapshot): boolean {
    const { url } = nextState
    const urlParts = url.includes('?') && url.split('?')
    return urlParts && urlParts[0] === '/dashboard/billing_info/edit' && urlParts[1].includes('returnUrl')
  }
}
